// Maps the canonical InventoryConfiguration#default_type value (DB-stored,
// shared with Papercut) to the user-facing "Scales with" label.
export const SCALES_WITH_OPTIONS = [
  { value: 'Pax Based',         label: 'Guests' },
  { value: 'Line Based',        label: 'Lines' },
  { value: 'Way Based',         label: 'Ways' },
  { value: 'Way to Line Ratio', label: 'Way to line ratio' },
  { value: 'Static',            label: 'Does not scale' },
  { value: 'Computed',          label: 'Multiplier' },
];

export function getScalesWithLabel(value: string | null | undefined): string {
  return SCALES_WITH_OPTIONS.find((o) => o.value === value)?.label ?? value ?? '';
}
